import { format } from "date-fns";
import { ArtistService } from "../../services/ArtistService";
import { StorageConstants } from "../../storage/storageConstants";
import {
  SET_LOADING,
  SET_ARTIST_LIST,
  SET_ARTIST_LIST_META,
  SET_ARTIST,
  SET_ARTIST_AUDITION,
  SET_ARTIST_IMAGES,
  SET_ARTIST_VIDEOS,
  SET_ARTIST_AUDIOS,
} from "./types";
import { replaceCountryCode } from "../../../utils";
import { basicProfilecategory } from "../../../constants";

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist list
 */
export const setArtistList = (data) => ({
  type: SET_ARTIST_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist list meta
 */
export const setArtistListMeta = (data) => ({
  type: SET_ARTIST_LIST_META,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist data
 */
export const setArtist = (data) => ({
  type: SET_ARTIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist data
 */
export const setArtistAuditions = (data) => ({
  type: SET_ARTIST_AUDITION,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist Image
 */
export const setArtistImages = (data) => ({
  type: SET_ARTIST_IMAGES,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist Video
 */
export const setArtistVideos = (data) => ({
  type: SET_ARTIST_VIDEOS,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set Artist Audio
 */
export const setArtistAudios = (data) => ({
  type: SET_ARTIST_AUDIOS,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Artist list
 */
export const getArtistList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await ArtistService.getArtistList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtistList(res?.data[0]));
        await dispatch(setArtistListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Artist By id
 */
export const getArtistById =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.getArtistById(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtist(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to delete artist profiles
 */
export const deleteArtistProfiles =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.deleteArtists(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtist(""));
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in logout: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to delete artist profiles
 */
export const markArtistVerified =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.markArtistVerified(params)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in logout: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Artist Auditions By id
 */
export const getArtistAuditions =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.getArtistAuditionList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtistAuditions(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist audition list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Artist Image By id
 */
export const getArtistImages =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.getImagesList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtistImages(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist Images list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Artist Video By id
 */
export const getArtistVideos =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.getVideoList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtistVideos(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist Video list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to get Artist Audio By id
 */
export const getArtistAudios =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.getAudioList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtistAudios(res?.data[0]));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist Audio list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

export const fetchArtistDataById =
  (params, successCallback, errorCallback) => async (dispatch) => {
    let promises = [];
    promises.push(dispatch(getArtistById(params, () => {}, errorCallback)));
    promises.push(
      dispatch(getArtistAuditions(params, () => {}, errorCallback))
    );
    promises.push(dispatch(getArtistImages(params, () => {}, errorCallback)));
    promises.push(dispatch(getArtistVideos(params, () => {}, errorCallback)));
    promises.push(dispatch(getArtistAudios(params, () => {}, errorCallback)));
    return Promise.all(promises)
      .then((res) => successCallback())
      .catch((err) => console.log(err))
      .finally(() => dispatch(setLoading(null)));
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to update artist profiles
 */
export const updateArtistProfiles =
  (data, successCallback, errorCallback) => async (dispatch) => {
    const profileCategories = [];
    if (data?.isActor && data.profileCategoryId !== basicProfilecategory.ACTOR)
      profileCategories.push({ id: basicProfilecategory.ACTOR });
    if (data?.isModel && data.profileCategoryId !== basicProfilecategory.MODEL)
      profileCategories.push({ id: basicProfilecategory.MODEL });
    if (
      data?.isInfluencer &&
      data.profileCategoryId !== basicProfilecategory.INFLUENCER
    )
      profileCategories.push({ id: basicProfilecategory.INFLUENCER });
    console.log("Print the data here >>> ", data);
    const request = {
      userId: data.userId,
      firstName: data.firstName,
      lastName: data.lastName,
      contactVisibility: data.contactVisibility,
      userProfile: {
        profileCategory: {
          id: data.profileCategoryId,
        },
        profileCategories,
        location: data.location,
        gender: data.gender,
        dob: format(new Date(data?.dob), "yyyy-MM-dd"),
        bio: data.bio,
        businessMobileNo: replaceCountryCode(data.businessMobileNo),
        businessEmail: data.businessEmail,
        nationality: data.nationality,
        experienceCategory: data.experienceCategory,
        experienceYears: data.experienceYears,
      },
    };
    await ArtistService.updateArtist(request)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in updating Artist: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to add artist profile
 */
export const addNewArtistProfile =
  (data, successCallback, errorCallback) => async (dispatch) => {
    const profileCategories = [];
    if (data?.isActor)
      profileCategories.push({ id: basicProfilecategory.ACTOR });
    if (data?.isModel)
      profileCategories.push({ id: basicProfilecategory.MODEL });
    if (data?.isInfluencer)
      profileCategories.push({ id: basicProfilecategory.INFLUENCER });
    const request = {
      firstName: data.firstName,
      lastName: data.lastName,
      mobileNo: replaceCountryCode(data.mobileNo),
      contactVisibility: data.contactVisibility,
      email: data.email,
      userProfile: {
        profileCategory: {
          id: data.profileCategoryId,
        },
        profileCategories,
        location: data.location,
        gender: data.gender,
        dob: format(new Date(data?.dob), "yyyy-MM-dd"),
        bio: data.bio,
        businessMobileNo: replaceCountryCode(data.businessMobileNo),
        businessEmail: data.businessEmail,
        nationality: data.nationality,
        experienceCategory: data.experienceCategory,
        experienceCategory: data.experienceCategory,
        experienceYears: data.experienceYears,
      },
    };
    await ArtistService.addArtist(request)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in updating Artist: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @description to delete artist profiles
 */
export const markArtistShowcase =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await ArtistService.markArtistShowcase(params)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in make showcase: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
